/* https://brandplatform.smartphoto.com/general/popups/loading-dialog/ */
import { disableUserEvents, expressQuerySelector, expressToggleClass } from "../../common/html";
import { IDisposable } from "../../utils/disposable";

export function showLoadingDialog<T>(
	promise: Promise<T>,
	timeToShowLoadingDialog = 200,
	extraTimeOutAfterResolving?: number,
	timeoutToDisableLoadingDialog?: number,
): Promise<T> {
	const bodyEl = expressQuerySelector(document, "body", true);
	const dialogEl = expressQuerySelector<HTMLElement>(bodyEl, ".technical-loading-dialog", true);

	const toggleClasses = (show: boolean) => {
		expressToggleClass(dialogEl, "u-hide", !show);
	};

	const show = setTimeout(() => toggleClasses(true), timeToShowLoadingDialog);
	const blockingEventDisposables = disableUserEvents();
	let manualTimeoutToDisableLoadingDialog;
	const disableLoadingDialog = () => {
		clearTimeout(show);
		if (manualTimeoutToDisableLoadingDialog) clearInterval(manualTimeoutToDisableLoadingDialog);
		blockingEventDisposables.dispose();
		toggleClasses(false);
	};

	if (timeoutToDisableLoadingDialog)
		manualTimeoutToDisableLoadingDialog = setInterval(() => disableLoadingDialog(), timeoutToDisableLoadingDialog);

	return promise.finally(() => {
		if (extraTimeOutAfterResolving) {
			setTimeout(() => disableLoadingDialog(), extraTimeOutAfterResolving);
		} else disableLoadingDialog();
	});
}
